<div class="w-full flex justify-start items-start">
  <div class="flex flex-col justify-center items-start">
    <label class="custom-checkbox font-bold">
      <input
        type="checkbox"
        class="hidden"
        [(ngModel)]="check"
        #checkItem
        (ngModelChange)="selectedItem(checkItem.checked)"
      />
      <span
        class="checkbox flex justify-center items-center w-5 h-5 border-primary-900 border shadow-md mr-2 transition-all duration-200"
        [ngClass]="{
          'checkbox-ok': check
        }"
      ></span>
      {{ returnName(data) }}
    </label>
  </div>
</div>
